import { useState, useEffect } from 'react'
import styles from './ServicesSection.module.scss'
import SectionTitle from '../SectionTitle/SectionTitle'

const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function ServicesSection() {
	const [services, setServices] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)

	useEffect(() => {
		fetch(`${API_PREFIX}/api/sections/get/services/list`)
			.then((res) => {
				if (!res.ok) throw new Error('Ошибка загрузки сервисов')
				return res.json()
			})
			.then((data) => {
				setServices(data.services ?? [])
				setLoading(false)
			})
			.catch((e) => {
				setError(e.message)
				setLoading(false)
			})
	}, [])

	const handleRegister = () => {
		setTimeout(() => {
			const formSection = document.getElementById('form-section')
			if (formSection) {
				const rect = formSection.getBoundingClientRect()
				const scrollTop =
					window.pageYOffset || document.documentElement.scrollTop
				const offsetTop = rect.top + scrollTop
				const centerOffset = window.innerHeight / 2 - rect.height / 2
				window.scrollTo({
					top: offsetTop - centerOffset,
					behavior: 'smooth',
				})
			}
		}, 300)
	}

	return (
		<section id='pricing' className={styles.servicesSection}>
			<SectionTitle>Стоимость</SectionTitle>
			{loading && <div>Загрузка...</div>}
			{error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}
			{!loading && !error && (
				<div className={styles.servicesWrapper}>
					{services.map((service) => (
						<div className={styles.serviceCard} key={service.id}>
							<div className={styles.serviceBadge}>{service.price}</div>
							<div className={styles.serviceMain}>
								<div className={styles.serviceContent}>
									<h3 className={styles.serviceTitle}>{service.title}</h3>
									<ul className={styles.serviceList}>
										{service.description?.map((text, i) => (
											<li key={i}>{text}</li>
										))}
									</ul>
								</div>
								<div className={styles.serviceImage}>
									<img
										src={
											service.image && service.image.startsWith('/')
												? API_PREFIX + service.image
												: service.image
										}
										alt={service.title}
									/>
								</div>
							</div>
							<button className={styles.serviceButton} onClick={handleRegister}>
								Записаться
							</button>
						</div>
					))}
				</div>
			)}
		</section>
	)
}
